import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { GeofenceService } from 'src/app/services/geofence.service';

@Component({
  selector: 'app-geofence-file-uploader',
  templateUrl: './geofence-file-uploader.component.html',
  styleUrls: ['./geofence-file-uploader.component.scss']
})
export class GeofenceFileUploaderComponent implements OnInit {

  public fileData: File = null;
  public fileName: string = "No file Chosen";
  public fileSize: any = "";
  public allowedFileTypes: any = ["text/csv"];

  public progress: number = -1;
  public errorCount: any = 0;
  public passCount: any = 0;

  constructor( 
    public dialogRef: MatDialogRef<GeofenceFileUploaderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastrService: ToastrService,
    public geofenceService: GeofenceService) {
  }

  ngOnInit() {
    // console.log("GEOFENCE IMPORT");
  }

  fileProgress(fileInput: any) {
    let fileData = <File>fileInput.target.files[0];
    if (this.allowedFileTypes.includes(fileData.type)) {
      this.fileData = fileData;
      this.fileName = fileData.name;
      this.fileSize = fileData.size;
      this.toastrService.info("File : " + this.fileName + " ; Size: " + this.fileSize, "File Selected");
    } else {
      this.fileData = null;
      this.fileName = "No file chosen";
      this.fileSize = "";
      this.toastrService.warning("Please select correct file", "Wrong File Type Error");
    }
  }

  public readFile(){

    if(this.fileData) {
        let reader: FileReader = new FileReader();
        reader.readAsText(this.fileData);
        
        reader.onload = (e) => {
          let payloadArr = [];
          let csv: string = reader.result as string;
          let rowArr = csv.split('\r\n');

          if(rowArr){
            for(let i=0;i<rowArr.length;i++){
              if(rowArr[i] && rowArr[i] != ""){
                let colArr = rowArr[i].split(',');
                console.log(colArr);
                if(i === 0 && !(colArr && colArr.length >= 1 && colArr[0] === 'Geofence ID')){
                  this.toastrService.error("Please follow Sample CSV ","Invalid Excel Header")
                  break;
                }
                if(colArr && colArr.length >= 1 && colArr[0] !== 'Geofence ID') {
                  let geofenceId = colArr[0];
                  let geofenceName = colArr[1];
                  let description = colArr[2];

                  if(geofenceName.trim() != '' && description.trim() != ''){
                      payloadArr.push({"geofenceId": geofenceId, "geofenceName": geofenceName, "geofenceDesc": description});
                      this.passCount += 1;
                  }
                  else{
                    this.errorCount += 1;
                  }
                }
              }
            }
          }

          if(payloadArr && payloadArr.length > 0){
            this.bulkUpload(payloadArr);
          }
        }        
      }
  }

  bulkUpload(payloadArr){
    this.geofenceService.addBulkGeofence(payloadArr)
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.toastrService.success(response.value, "Geofence Added Successfully!");
          if(this.errorCount > 0){
            this.toastrService.info(this.passCount + ' Geofence Added, </br>' + this.errorCount + ' Failed','Result',{ enableHtml:true });
          }
          else{
            this.toastrService.info(this.passCount + ' Geofence Added','Result',{ enableHtml:true });
          }
          this.closeDialog();
        } 
        else {
          this.toastrService.error(response.value, "Failed To Add Geofence!")
          this.closeDialog();
        }
      });
  }

  chooseFile() {
    let myInput = document.getElementById("myInput");
    myInput.click();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
